/**
 * Represents the actual state of the application on site. Do not confuse with the State in the old MetaSiteDTO,
 * which has less values and doesn't have 1-to-1 correspondence with this one (this one is exact and correct!)
 */
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    /** App is installed on a site. */
    State["ENABLED"] = "ENABLED";
    /** App is removed from a site (but we preserve it just in case). */
    State["DISABLED"] = "DISABLED";
    /** App is in "demo" mode, meaning that it's in read-only mode (it's in a template OR not installed yet). */
    State["TEMPLATE"] = "TEMPLATE";
    /** App is not installed, there is a user intention for it only (user will see the pimpl in the editor). */
    State["PENDING"] = "PENDING";
})(State || (State = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
    Namespace["NOWNIA"] = "NOWNIA";
    /**
     * UGC Templates are templates that are created by users for personal use and to sale to other users.
     * The Partners company owns this namespace.
     */
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    /** Codux Headless Sites */
    Namespace["CODUX"] = "CODUX";
    /** Bobb - AI Design Creator. */
    Namespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
    /**
     * Shared Blog Site is a unique single site across Enterprise account,
     * This site will hold all Blog posts related to the Marketing product.
     */
    Namespace["SHARED_BLOG_ENTERPRISE"] = "SHARED_BLOG_ENTERPRISE";
    /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_FORMS"] = "STANDALONE_FORMS";
    /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_EVENTS"] = "STANDALONE_EVENTS";
    /** MIMIR - Siteless account for MIMIR Ai Job runner. */
    Namespace["MIMIR"] = "MIMIR";
})(Namespace || (Namespace = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["UNKNOWN_DOCUMENT_TYPE"] = "UNKNOWN_DOCUMENT_TYPE";
    /** User Generated Content - user site */
    DocumentType["UGC"] = "UGC";
    /** Sites used for template */
    DocumentType["TEMPLATE"] = "TEMPLATE";
    /** Wix's Landing Pages, marketing pages, Wix Home Page etc. */
    DocumentType["WIX_SITE"] = "WIX_SITE";
})(DocumentType || (DocumentType = {}));
export var PremiumFeature;
(function (PremiumFeature) {
    PremiumFeature["UNKNOWN_PREMIUM_FEATURE"] = "UNKNOWN_PREMIUM_FEATURE";
    PremiumFeature["SHOW_WIX_WHILE_LOADING"] = "SHOW_WIX_WHILE_LOADING";
    PremiumFeature["ADS_FREE"] = "ADS_FREE";
    PremiumFeature["HAS_ECOMMERCE"] = "HAS_ECOMMERCE";
    PremiumFeature["HAS_DOMAIN"] = "HAS_DOMAIN";
    PremiumFeature["ALWAYS_SHOW_FOOTER"] = "ALWAYS_SHOW_FOOTER";
    PremiumFeature["NO_ADS_IN_SOCIAL_SITES"] = "NO_ADS_IN_SOCIAL_SITES";
})(PremiumFeature || (PremiumFeature = {}));
export var ApplicationType;
(function (ApplicationType) {
    ApplicationType["UNKNOWN_APPLICATION_TYPE"] = "UNKNOWN_APPLICATION_TYPE";
    ApplicationType["FLASH"] = "FLASH";
    ApplicationType["FLASH_FACEBOOK"] = "FLASH_FACEBOOK";
    ApplicationType["FLASH_WIDGET"] = "FLASH_WIDGET";
    ApplicationType["FLASH_BANNER"] = "FLASH_BANNER";
    ApplicationType["HTML_MOBILE"] = "HTML_MOBILE";
    ApplicationType["HTML_WEB"] = "HTML_WEB";
    ApplicationType["HTML_FACEBOOK"] = "HTML_FACEBOOK";
    ApplicationType["BLOG"] = "BLOG";
    ApplicationType["WIX_LISTS"] = "WIX_LISTS";
    /** Used only for wix sites used only. Basically proxy the request to the source outside of Wix. */
    ApplicationType["STATIC_MOUNT"] = "STATIC_MOUNT";
    /** Used only for wix sites used only. Basically redirects the request to the source outside of Wix */
    ApplicationType["STATIC_MOUNT_REDIRECT"] = "STATIC_MOUNT_REDIRECT";
    ApplicationType["AMP_BLOG"] = "AMP_BLOG";
    ApplicationType["COMMUNITIES_AMP_BLOG"] = "COMMUNITIES_AMP_BLOG";
    ApplicationType["HTML_ANYWHERE"] = "HTML_ANYWHERE";
    ApplicationType["HOPP"] = "HOPP";
})(ApplicationType || (ApplicationType = {}));
export var Compatibility;
(function (Compatibility) {
    Compatibility["UNKNOWN_COMPATIBILITY"] = "UNKNOWN_COMPATIBILITY";
    Compatibility["WEB"] = "WEB";
    Compatibility["MOBILE"] = "MOBILE";
    Compatibility["ALL"] = "ALL";
})(Compatibility || (Compatibility = {}));
export var ApiState;
(function (ApiState) {
    ApiState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    ApiState["TEMPLATE"] = "TEMPLATE";
    ApiState["STUB"] = "STUB";
    ApiState["INITIALIZED"] = "INITIALIZED";
})(ApiState || (ApiState = {}));
export var Kind;
(function (Kind) {
    Kind["OPEN"] = "OPEN";
    Kind["CLOSED"] = "CLOSED";
    Kind["APPLY_FOR_MEMBERSHIP"] = "APPLY_FOR_MEMBERSHIP";
})(Kind || (Kind = {}));
export var FormFace;
(function (FormFace) {
    FormFace["REGISTER"] = "REGISTER";
    FormFace["LOGIN"] = "LOGIN";
})(FormFace || (FormFace = {}));
export var CollectionExposure;
(function (CollectionExposure) {
    CollectionExposure["PUBLIC"] = "PUBLIC";
    CollectionExposure["WIX_INTERNAL"] = "WIX_INTERNAL";
})(CollectionExposure || (CollectionExposure = {}));
export var HttpsPolicy;
(function (HttpsPolicy) {
    HttpsPolicy["UNKNOWN_HTTPS_POLICY"] = "UNKNOWN_HTTPS_POLICY";
    HttpsPolicy["DISALLOW"] = "DISALLOW";
    HttpsPolicy["ALLOW"] = "ALLOW";
    HttpsPolicy["ENFORCE"] = "ENFORCE";
})(HttpsPolicy || (HttpsPolicy = {}));
export var Flag;
(function (Flag) {
    /** Unknown flag. */
    Flag["UNKNOWN_FLAG"] = "UNKNOWN_FLAG";
    /**
     * ECOM_TEST_DRIVE = 1 [deprecated = true];
     * ECOM_MIGRATED = 2 [deprecated = true];
     * If present, forces usage of wixsite.com/editorx.io for free site + no usage of #!.
     */
    Flag["URL_MIGRATED"] = "URL_MIGRATED";
    /** Indicates whether HTTPS is used for accessing site. */
    Flag["USE_HTTPS"] = "USE_HTTPS";
    /** Indicates that the site is managed by Editor X. Implications: different domain (editorx.com and editorx.io). */
    Flag["EDITOR_X"] = "EDITOR_X";
    /** Indicates metasite blocked from publishing and added additional filtering in listing API (MSS). READ_ONLY. */
    Flag["BLOCKED"] = "BLOCKED";
    /**
     * Indicates that default routing won't be used for this meta site. Additionally it means that this meta site
     * doesn't have viewer url based on meta site data.
     *
     * Default routing is based on domains, free url, ML etc. None of it will be used. This feature is needed
     * when routing is defined completely in Routes API (routes-writer or meta-site-routes).
     */
    Flag["DONT_USE_DEFAULT_ROUTING"] = "DONT_USE_DEFAULT_ROUTING";
    /** Indicates the site is managed bv Wix Studio. Implications: different domain */
    Flag["STUDIO"] = "STUDIO";
    /** Indicates the site is used as critical asset and as such is protected. You would be only able to provision applications to this meta site. */
    Flag["CRITICAL_ASSET"] = "CRITICAL_ASSET";
    /** Indicates that site is managed by Odeditor */
    Flag["ODEDITOR"] = "ODEDITOR";
    /** Indicates that site is managed by Picasso */
    Flag["PICASSO"] = "PICASSO";
})(Flag || (Flag = {}));
export var PendingReason;
(function (PendingReason) {
    PendingReason["UNKNOWN"] = "UNKNOWN";
    PendingReason["PREMIUM"] = "PREMIUM";
    PendingReason["APP_MARKET"] = "APP_MARKET";
})(PendingReason || (PendingReason = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    /** Render site for language using query param. eg: https://www.alonkochba.com/?lang=fr */
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    /** Render site for language using subdomain. eg: https://fr.alonkochba.com/ */
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    /** Render site for language using subdirectory. eg: https://www.alonkochba.com/fr */
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
    DeleteStatus["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(DeleteStatus || (DeleteStatus = {}));
export var Context;
(function (Context) {
    Context["UNKNOWN"] = "UNKNOWN";
    /** Creation of the site (might be from template, clone, blank site, etc). */
    Context["CREATE"] = "CREATE";
    /** Update of the existing site. */
    Context["UPDATE"] = "UPDATE";
    /** Deletion of the site FOREVER (shouldn't present in db anymore). */
    Context["HARD_DELETE"] = "HARD_DELETE";
    /** Soft deletion of the site (could be restored). */
    Context["ARCHIVE"] = "ARCHIVE";
    /** Restoration of a soft deleted site. */
    Context["RESTORE"] = "RESTORE";
    /** Update of deleted meta site. Happens rarely, only because of data migrations. */
    Context["UPDATE_DELETED"] = "UPDATE_DELETED";
    /** notify about deleted site. */
    Context["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(Context || (Context = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var AssetState;
(function (AssetState) {
    AssetState["UNKNOWN"] = "UNKNOWN";
    AssetState["ENABLED"] = "ENABLED";
    AssetState["DISABLED"] = "DISABLED";
    AssetState["PENDING"] = "PENDING";
    AssetState["DEMO"] = "DEMO";
})(AssetState || (AssetState = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var V4ResolutionMethod;
(function (V4ResolutionMethod) {
    V4ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    V4ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    V4ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(V4ResolutionMethod || (V4ResolutionMethod = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var Cause;
(function (Cause) {
    Cause["EMPTY"] = "EMPTY";
    Cause["NAMESPACE_LIMIT_REACHED"] = "NAMESPACE_LIMIT_REACHED";
    Cause["AUTOMATION_USER_LIMIT_REACHED"] = "AUTOMATION_USER_LIMIT_REACHED";
    Cause["WIX_EMPLOYEE_LIMIT_REACHED"] = "WIX_EMPLOYEE_LIMIT_REACHED";
})(Cause || (Cause = {}));
export var UrlFilter;
(function (UrlFilter) {
    UrlFilter["NO_URL_TYPE_FILTER"] = "NO_URL_TYPE_FILTER";
    UrlFilter["FREE"] = "FREE";
})(UrlFilter || (UrlFilter = {}));
export var MigrationResult;
(function (MigrationResult) {
    /** Default value. This value is unused. */
    MigrationResult["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    /** Site was migrated successfully */
    MigrationResult["OK"] = "OK";
    /** Site was not migrated due to one of the reasons: Site not exist, CloudSiteExtension not installed, requested TPAs are already installed. */
    MigrationResult["SKIP"] = "SKIP";
})(MigrationResult || (MigrationResult = {}));
export var MigrateEmbeddedServiceToTpaResponseMigrationResult;
(function (MigrateEmbeddedServiceToTpaResponseMigrationResult) {
    /** Default value. This value is unused. */
    MigrateEmbeddedServiceToTpaResponseMigrationResult["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    /** Site was migrated successfully */
    MigrateEmbeddedServiceToTpaResponseMigrationResult["OK"] = "OK";
    /** Site was not migrated due to one of the reasons: Site not exist, Embedded service not installed, requested TPA is already installed. */
    MigrateEmbeddedServiceToTpaResponseMigrationResult["SKIP"] = "SKIP";
})(MigrateEmbeddedServiceToTpaResponseMigrationResult || (MigrateEmbeddedServiceToTpaResponseMigrationResult = {}));
//# sourceMappingURL=types.impl.js.map